/**
* Feature Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Feature Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'feature-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      let topTallestCard = 0;
      $( '.splide-top .feature-card' ).each( function() {
        if ( $( this ).height() > topTallestCard ) {
          topTallestCard = $( this ).height();
        }
      } );
      $( '.splide-top .feature-card' ).each( function() {
        $( this ).height( topTallestCard );
      } );
      let bottomTallestCard = 0;
      $( '.splide-bottom .feature-card' ).each( function() {
        if ( $( this ).height() > bottomTallestCard ) {
          bottomTallestCard = $( this ).height();
        }
      } );
      $( '.splide-bottom .feature-card' ).each( function() {
        $( this ).height( bottomTallestCard );
      } );
      new Splide( '.feature-marquee .splide-top', {
        type: 'loop',
        drag: 'free',
        focus: 'center',
        autoWidth: true,
        arrows: false,
        pagination: false,
        autoScroll: {
          speed: 1,
        },
      } ).mount( {AutoScroll} );
      new Splide( '.feature-marquee .splide-bottom', {
        type: 'loop',
        drag: 'free',
        focus: 'center',
        autoWidth: true,
        autoHeight: false,
        arrows: false,
        pagination: false,
        autoScroll: {
          speed: -1,
        },
      } ).mount( {AutoScroll} );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'feature-marquee', COMPONENT );
} )( app );
